/* jshint -W079 */
define([
        'jquery',
    ],
    function ($) {
        return {
            init() {
                this.initCache();
                this.initEvents();
            },

            initCache() {
                this.$body = $('body');
            },

            initEvents() {
                this.$body.on('change_shade', this.initProductEvent)
                this.$body.on('click', '.js-tryon-landing-category', this.initHomeTryonEvent)
                this.$body.on('click', '.js-tryon-btn', this.initCategoryTryonEvent)
                this.$body.on('review_gtm_event', this.initReviewEvent)
            },

            initProductEvent(ev, isFirstSwatch, productName, upc, shade) {
                if (typeof dataLayer !== 'undefined') {
                    dataLayer.push({
                        event: 'uaevent',
                        ecommerce: 'undefined',
                        eventCategory: 'Ecommerce',
                        eventAction: isFirstSwatch ? 'Product Detail' : 'Variant Selection',
                        eventLabel: `${productName}::${upc}::${shade}`,
                        productID: upc
                    });
                }
            },

            initHomeTryonEvent(e) {
                const $target = $(e.currentTarget);
                const productCategory = $target.data('product-category')
                const category = $target.data('category')

                if (typeof dataLayer !== 'undefined') {
                    dataLayer.push({
                        event: 'uaevent',
                        ecommerce: 'undefined',
                        eventCategory: 'virtual try on::modiface::make-up',
                        eventAction: `select::${productCategory}`,
                        eventLabel: category
                    });
                }
            },

            initCategoryTryonEvent(e) {
                const $target = $(e.currentTarget).closest('.js-product-item');
                const productCategory = $target.data('product-category')
                const productName = $target.data('product-name')
                const productSku = $target.data('product-sku')
                const productShade = $target.data('product-shade')

                if (typeof dataLayer !== 'undefined') {
                    dataLayer.push({
                        event: 'uaevent',
                        ecommerce: 'undefined',
                        eventCategory: 'virtual try on::modiface::make-up',
                        eventAction: `select::${productCategory}`,
                        eventLabel: `${productName}::${productSku}::${productShade}`
                    });
                }
            },

            initReviewEvent() {
                const product = window.currentProduct[Object.keys(window.currentProduct)[0]];

                if (typeof dataLayer !== 'undefined') {
                    dataLayer.push({
                        event: 'uaevent',
                        ecommerce: 'undefined',
                        eventCategory: 'product detail page',
                        eventAction: 'review impression',
                        eventLabel: `${product.prod_name}::${product.upc}`
                    });
                }
            },
        };
    });
